import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FuelFormList() {
    const token = localStorage.getItem("authToken") || null;
    const navigate = useNavigate();
     
    const [fuelFormList, setFuelFormList] = useState([]);
   const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortOrder, setSortOrder] = useState("asc");
    const [isLoading, setIsLoading] = useState(true);

    const fetchFuelFormList = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/getFuelForms`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'AUTHORIZATION': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('API Response:', data);

            // Access the 'data' array inside the response
            setItems(data.data);
            setFuelFormList(Array.isArray(data.data) ? data.data : []);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching fuel forms:', error);
            setFuelFormList([]);
        }
    };

    useEffect(() => {
        fetchFuelFormList();
    }, [API_BASE_URL, token]);

      useEffect(() => {
        if (!Array.isArray(items)) {
            setFilteredItems([]);
            return;
        }
        
        const filtered = items.filter(item => {
            const name = item.name ? item.name.toLowerCase() : "";
            const id = item.id ? item.id.toLowerCase() : "";
    
            return (
                name.includes(searchQuery.toLowerCase()) ||
                id.includes(searchQuery.toLowerCase())
            );
        });
    
        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });
    
        setFilteredItems(sorted);
        setCurrentPage(1); // Reset to first page when items or search query changes
    }, [searchQuery, items, sortColumn, sortOrder]);
    
  
    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
  
    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);
  
    const handleSearchChange = e => {
        setSearchQuery(e.target.value);
    };
  
    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };
  
    const handleItemsPerPageChange = e => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };
  
    const handleSort = column => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc"); 
        }
    };
 
    const createNewForm = async () => {
        navigate('/add_fuel_form');
        // try {
        //     const response = await fetch(`${API_BASE_URL}addFuelForm`, {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //             'AUTHORIZATION': `Bearer ${token}`
        //         },
        //     });
        //     const data = await response.json();
        //    // console.log('API Responsesss:', data);
        //     if (data.status === true) {
        //         console.log('Fuel Form Created : ', data);
        //         navigate('/fuel_form/' + data.id);
                
        //     } else {
        //         console.log('Fuel Form Creation Failed...');
        //     }

        // } catch (error) {
        //     console.log('Fuel Form Creation Failed');
        // }
    }

   

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className='m-0' style={{ fontSize: '20px' }}>Fuel Forms List</h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Fuel Forms</h3>
                                            <div className="card-tools">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm d-inline mr-2"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={handleSearchChange}
                                                    style={{ width: '150px' }}
                                                />
                                                <button onClick={createNewForm} className="btn btn-primary btn-sm">
                                                    Create New Form
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {isLoading ? (
                                                <p>Loading...</p>
                                            ) : fuelFormList.length === 0 ? (
                                                <p>No fuel forms found.</p>
                                            ) : (
                                                <>
                                                    <table className="table table-hover text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Driver</th>
                                                                <th>Submit Status</th>
                                                                <th>Amount</th>
                                                                <th onClick={handleSort} style={{ cursor: 'pointer' }}>
                                                                    CreatedOn {sortOrder === 'asc' ? '↑' : '↓'}
                                                                </th>
                                                                <th>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {currentItems.length > 0 ? (
																	currentItems.map((fuelForm, index) => (
                                                                        <tr key={index}>
                                                                        <td>
                                                                            {index +
                                                                                1 +
                                                                                (currentPage - 1) * itemsPerPage}
                                                                        </td>
                                                                    <td>{fuelForm.emp_code}</td>
                                                                    <td>{fuelForm.isSubmited}</td>
                                                                    <td>{fuelForm.total_fuel_amt}</td>
                                                                    <td>{new Date(fuelForm.createdDTM).toLocaleString()}</td>
                                                                    <td>
                                                                        <Link to={`/edit_fuel_form/${fuelForm.id}`} className="btn btn-sm btn-info">View</Link>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan='3'>No data available</td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                    </table>
                                                    <nav>
											<ul
												className='pagination'
												style={{ float: "right" }}>
												<li className='page-item'>
													<button
														className='page-link'
														onClick={() => handlePageChange(currentPage - 1)}
														disabled={currentPage === 1}>
														Previous
													</button>
												</li>
												{[...Array(totalPages).keys()].map(pageNumber => (
													<li
														key={pageNumber}
														className={`page-item ${
															pageNumber + 1 === currentPage ? "active" : ""
														}`}>
														<button
															className='page-link'
															onClick={() => handlePageChange(pageNumber + 1)}>
															{pageNumber + 1}
														</button>
													</li>
												))}
												<li className='page-item'>
													<button
														className='page-link'
														onClick={() => handlePageChange(currentPage + 1)}
														disabled={currentPage === totalPages}>
														Next
													</button>
												</li>
											</ul>
										</nav>
										<div className='mb-3'>
											Showing {startItem} to {endItem} of {filteredItems.length}{" "}
											entries
										</div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default FuelFormList;
